import React from "react"
import { styled } from '@mui/material/styles'

const Transparency = styled('div')(({ theme }) => ({
    // backgroundColor: theme.palette.background.paper,
    backgroundColor: "rgba(0,0,0,0.1)"
}));

export default function OpaqueTransparencySection(props) {
    const {children} = props

    return (
        <Transparency>    
            {children}
        </Transparency>
    )
}